import { Grid, GridColumn, GridDetailRowProps } from '@progress/kendo-react-grid';
import React, { FC } from 'react';

const POHistoryDetailGrid: FC<React.PropsWithChildren<GridDetailRowProps>> = ({ dataItem }) => {
  return (
    <Grid data={dataItem?.poHistoryDetail}>
      <GridColumn field="lineNumber" title="Line" width={50} />
      <GridColumn field="item" title="Item" />
      <GridColumn field="vendorItem" title="Vendor Item" />
      <GridColumn field="fieldName" title="Field Name" />
      <GridColumn field="oldValue" title="Old Value" />
      <GridColumn field="newValue" title="New Value" />
      <GridColumn field="notes" title="Notes" />
    </Grid>
  );
};

export default POHistoryDetailGrid;
